import request from "./request";


const QuizService = {
 // QUIZ 
  GetAllQuizzes: async (videoId, context) => {
    return await request.sendRequest(
      `/quiz/all/${videoId}`,
      context?.token
    );
  },


  PostQuiz: async (payload, context) => {
    return await request.sendPostRequest(
      "/quiz",
      payload,
      context
    );
  },

  PostBulkQuiz: async (payload, context) => {
    return await request.sendPostRequest(
      "/quiz/bulk",
      payload,
      context
    );
  },

  ImportQuiz: async (videoId, payload, context) => {
    return await request.sendFormDataRequest(
      `/quiz/import/${videoId}`,
      payload,
      context
    );
  },

  DeleteQuiz: async (id, context) => {
    return await request.sendDeleteRequest(
      `/quiz/${id}`,
      context?.token
    );
  },
  GetAllQuizzesForExam: async (videoId, context) => {
    return await request.sendRequest(
      `/quiz/exam/all/${videoId}`,
      context?.token
    );
  },


  SaveQuiz: async (payload, context) => {
    return await request.sendPostRequest(
      "/quiz/exam",
      payload,
      context
    );
  },

StartQuizExam: async (videoId, context) => {
  return await request.sendPutRequest(
    `/quiz/exam/start/${videoId}`,
    context
  );
},

  RecalculateScores: async (videoId, context) => {
    return await request.sendPutRequest(
      `/quiz/exam/calculate/${videoId}`,
      context
    );
  },

 GetQuizSessions: async (videoId, searchText, context) => {
  const url = searchText
    ? `/quiz/exam/sessions/${videoId}/${searchText}`
    : `/quiz/exam/sessions/${videoId}`;

  return await request.sendRequest(url, context?.token);
},

GetQuizAttendees: async (take, skip, videoId, searchText, context) => {
  const url = searchText
    ? `/quiz/exam/attendees/${take}/${skip}/${videoId}/${searchText}`
    : `/quiz/exam/attendees/${take}/${skip}/${videoId}`;

  return await request.sendRequest(url, context?.token);
},


  RemoveQuizSession: async (videoId, userId, context) => {
    return await request.sendDeleteRequest(
      `/quiz/exam/session/${videoId}/${userId}`,
      context?.token
    );
  },



}
export default QuizService